import '../css-build/main.css';
import { Elm } from '../elm/LandingSite/Main.elm';

window.addEventListener('load', function() {
  const app = Elm.LandingSite.Main.init({
    node: document.getElementById('root') || document.getElementById('main'), // no pre-rendered // pre-rendered
    flags: {
      apiBaseUrlMap: process.env.API_BASE_URL_MAP,
      configAbiFiles: process.env.CONFIG_ABI_FILES,
      configurations: process.env.CONFIG_FILES,
      language: window.navigator.language,
      protoDocJson: process.env.SERVICE_CONFIG,
      path: window.location.href,
      targetNetwork: process.env.LANDING_TARGET_NETWORK
    }
  });

  function findParent(tagname, el) {
    if (!el) {
      return null;
    }

    if ((el.nodeName || el.tagName).toLowerCase() === tagname.toLowerCase()) {
      return el;
    }

    return findParent(tagname, el.parentNode);
  }

  document.addEventListener('click', e => {
    e = e || event;
    var from = findParent('a', e.target || e.srcElement);

    if (from && from.href && !from.rel && !e.metaKey) {
      history.pushState({}, '', from.href);
      e.preventDefault();
      app.ports.onUrlChange.send(from.href);
    }
  });

  // Inform app of browser navigation (the BACK and FORWARD buttons)
  let statePopped = false;
  window.addEventListener('popstate', () => {
    statePopped = true;
    app.ports.onUrlChange.send(location.href);
  });

  app.ports.scrollIntoView.subscribe(elementId => {
    let element = document.getElementById(elementId);

    if (element) {
      const top = element.offsetTop;
      window.scrollTo(0, top + 117);
    }
  });

  app.ports.scrollTop.subscribe(() => {
    if (!statePopped) {
      window.scrollTo(0, 0);
    } else {
      statePopped = false;
    }
  });

  let postRender = window.requestAnimationFrame;

  app.ports.highlightScroll.subscribe(([navLinkSelector, sectionSelector]) => {
    postRender(() => {
      highlightScroll(navLinkSelector, sectionSelector);
    });
  });

  app.ports.setTitle.subscribe(title => {
    document.title = title;
  });

  app.ports.copy.subscribe(text => {
    const el = document.createElement('textarea');
    el.value = text;
    el.setAttribute('readonly', '');
    el.style = { position: 'absolute', left: '-9999px' };
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  });
});
